<div>
  @if (successMessage) {
    <div class="success">{{ successMessage }}</div>
  }
  <vip-paginator
    [paginator]="classService.paginator"
    [requesting]="classService.loading"
    (pageChanged)="setPaginator($event)"
  ></vip-paginator>
  <div class="filters flex-filters">
    <div class="flex-filter-item">
      <text-filter
        prefixIcon="search"
        placeHolder="Category"
        [text]="classService.filterable.category.name"
        (textChange)="filterCategoryName($event)"
      ></text-filter>
    </div>
    <div class="flex-filter-item">
      <text-filter
        prefixIcon="search"
        placeHolder="Class"
        [text]="classService.filterable.name"
        (textChange)="filterClassName($event)"
      ></text-filter>
    </div>
  </div>
  <cdk-table-component
    [displayColumns]="displayColumns"
    [entities]="tableEntities"
    [dataSource]="dataSource"
    (rowClickAction)="viewClass($event)"
  ></cdk-table-component>
</div>
